export const SectionTemplate = () => ({
    type: "Container",
    items: [
        {
            type: "TextBlock",
            text: "New TextBlock",
            wrap: true,
            size: "large",
            weight: "bolder",
            isVisible: true
        },
        {
            type: "Image",
            isVisible: true,
            url: "http://adaptivecards.io/content/adaptive-card-50.png"
        },
        {
            type: "TextBlock",
            text: "Summary",
            wrap: true,
            isVisible: true
        }
    ]
});

export const NewsTemplateStructure = {
    type: "AdaptiveCard",
    version: "1.0",
    backgroundImage: {
        url: "/Content/colors/EFEFEF.png",
        fillMode: "Repeat"
    },
    actions: [

    ],
    body: [
        {
            type: "Container",
            items: [
                {
                    type: "TextBlock",
                    text: "OMC Insider",
                    wrap: true,
                    size: "large",
                    weight: "bolder",
                    isVisible: true
                },
                {
                    type: "Image",
                    isVisible: true,
                    url: "/Content/OMC-Insider.png"
                },
                {
                    type: "TextBlock",
                    wrap: true,
                    isVisible: true,
                    text: "",

                }
            ]
        },
        {
            type: "Container",
            isVisible: true,
            items: [
            ]
        },
    ],
};